import { Slide, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import './style.css'

export const contentTypeClass = {
  SUCCESS: 'success',
  ERROR: 'error',
  DEFAULT: 'default',
  INFO: 'info'
}

export const helperClassColors = {
  [contentTypeClass.SUCCESS]: 'bg-green-800',
  [contentTypeClass.ERROR]: 'bg-red-900',
  [contentTypeClass.DEFAULT]: 'bg-indigo-600',
  [contentTypeClass.INFO]: 'bg-blue-900'
}

export default function Toast() {
  return (
    <div className='w-full flex'>
      <ToastContainer
        position='bottom-center'
        closeButton={false}
        pauseOnHover
        hideProgressBar={false}
        autoClose={3000}
        transition={Slide}
        icon={false}
        toastClassName={({ type }) =>
          `${
            helperClassColors[type || contentTypeClass.DEFAULT]
          } relative flex shadow-header min-h-10 h-full overflow-hidden cursor-pointer`
        }
        style={{
          padding: 0,
          bottom: 0,
          width: '100%'
        }}
      />
    </div>
  )
}
